import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import FeaturedCourses from './components/FeaturedCourses';
import CategoriesSection from './components/CategoriesSection';
import WhyLearnFlow from './components/WhyLearnFlow';
import Testimonials from './components/Testimonials';
import CTASection from './components/CTASection';

export default function HomePage() {
  return (
    <div className="min-h-screen">
      <Navbar />
      <HeroSection />
      <FeaturedCourses />
      <CategoriesSection />
      <WhyLearnFlow />
      <Testimonials />
      <CTASection />
      <Footer />
    </div>
  );
}
